<div class="page-container">
  <app-titlebar #titlebar
    ></app-titlebar>
  <div class="page-content">
    <mat-toolbar class="h-9">
      <button class="btn-primary" (click)="doSubmit()">
        <mat-icon fontIcon="report"></mat-icon>立刻執行
      </button>
      <button class="btn-secondary" (click)="doClear()">
        <mat-icon fontIcon="search"></mat-icon>清除
      </button>
    </mat-toolbar>

      <app-jktextarea label="SSML 文字" [rows]="10" [(value)]="filterOpt.ssmlText"  [autoResizeEnabled]="true" [minHeight]="60" [maxHeight]="400"></app-jktextarea>
      <app-jkedit label="存檔檔名" placeholder="./wav/test.mp3" [(value)]="filterOpt.outFile"></app-jkedit>

  </div>
</div>
